import moment from 'moment';
import DateConstants from '#app/helpers/DateConstants';

/** Нормализация даты выплаты в YYYY-MM-DD. */
export function normalizeActivePayoutDate(value: unknown): string | null {
  if (value == null || value === '' || value === '-') return null;

  const m = moment(
    String(value),
    [
      DateConstants.dateTimeUserFormat,
      DateConstants.dateTimeFormat,
      'DD.MM.YYYY',
      'YYYY-MM-DD',
      moment.ISO_8601,
    ],
    true
  );

  return m.isValid() ? m.format('YYYY-MM-DD') : null;
}

export function isActivePayoutInRange(
  paidAt: string,
  fromDate: string | null | undefined,
  toDate: string | null | undefined
): boolean {
  if (!fromDate || !toDate) return true;

  const day = moment(paidAt, 'YYYY-MM-DD', true);
  const from = moment(fromDate, DateConstants.dateTimeFormat, true).startOf('day');
  const to = moment(toDate, DateConstants.dateTimeFormat, true).endOf('day');

  if (!day.isValid() || !from.isValid() || !to.isValid()) return true;

  return day.isBetween(from, to, 'day', '[]');
}
